import ReducerGenerator from '../../lib/ReducerGenerator'

const generator = new ReducerGenerator(
  'benefits_sets_av_calculator_enqueue',
  '/benefits_sets_av_calculator_enqueue'
)
const reducer = generator.generate()

export default reducer
